import store from "@/store";

export default function hasActiveNotCompletedWeightLossProgram({
  next,
  router,
}) {
  const hasActiveWeightLossProgram =
    store.getters["user/hasActiveWeightLossProgram"];
  const activeWeightLossProgramStatus =
    store.getters["user/activeWeightLossProgramStatus"];

  if (
    hasActiveWeightLossProgram &&
    ["new", "general_survey_filled", "results_ready"].includes(
      activeWeightLossProgramStatus
    )
  ) {
    return next();
  }

  return router.push({ name: "WeightLoss.Dashboard" });
}
